<div>
  <mat-form-field class="full-width">
    <input matInput placeholder="Fecha" [matDatepicker]="myDatepicker" [formControl]="date">
    <mat-datepicker-toggle matSuffix [for]="myDatepicker"></mat-datepicker-toggle>
    <mat-datepicker #myDatepicker></mat-datepicker>
  </mat-form-field>
  <mat-form-field class="full-width">
    <input matInput placeholder="Duración" [(ngModel)]="eventoMateria.duracion" [ngModelOptions]="{standalone: true}">
    <span matSuffix>min.</span>
  </mat-form-field>
  <app-evento-form-classroom [evento]="eventoMateria" [materia]="materiaPeriodo" [tareas]="tareas"
    [actual]="eventoMateria.courseWorkId" [editable]="true" class="full-width"></app-evento-form-classroom>
</div>
<button mat-button mat-dialog-close style="margin-right: 8px;">Cancelar</button>
<button mat-raised-button (click)="guardarMCP()" color="primary">Guardar</button>
